import { useContext } from 'react';
import CacheContext from 'src/context/CacheContext';

export default function useCache() {
    const {
        getFromCache,
        saveToCache,
        clearCache,
        invalidateByPrefix,
    } = useContext(CacheContext);

    return { getFromCache, saveToCache, clearCache, invalidateByPrefix };
}
